// extracted by mini-css-extract-plugin
export default {"formGroupExpand":"formGroupExpand_formGroupExpand__S1AFR","show":"formGroupExpand_show__M3fBp","icon":"formGroupExpand_icon__wtuKq"};